import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { warrantyExecutionFilters } from './warranty-execution.filters';

// `validateSearch` de /gestao-carteira/execucao-garantias (U07). Leve de propósito: é JS inicial.

const INT32_MAX = 2_147_483_647;
const asText = (value: unknown) => (typeof value === 'number' && Number.isFinite(value) ? String(value) : typeof value === 'boolean' ? String(value) : value);

/**
 * Número do contrato: só dígitos e dentro do int32 do backend (`WarrantyExecutionFiltersSchema.ts:11-23`).
 * Fora disso a CreditAPI responde 400; o valor inválido sai da URL em vez de derrubar a lista.
 */
const creditNoteNo = z
  .preprocess(asText, z.string().regex(/^\d+$/).refine((value) => Number(value) <= INT32_MAX))
  .optional()
  .catch(undefined);

/** Link colado com `?isOwnFund=true` chega como booleano: aceita como o texto do select. */
const boolText = z.preprocess(asText, z.enum(['true', 'false'])).optional().catch(undefined);

export const warrantyExecutionSearch = listSearchSchema({
  ...warrantyExecutionFilters.shape,
  creditNoteNo,
  isOwnFund: boolText,
  fundExecutionRequested: boolText,
});
export type WarrantyExecutionSearch = z.infer<typeof warrantyExecutionSearch>;
